module.exports = __webpack_public_path__ + "static/bebe2-245602e1e01bc5e17b1fcae6034a8435.png";